import {Component, OnInit} from '@angular/core';
import {TrabalhoService} from "../trabalho/trabalho.service";
import {Trabalho} from "../trabalho/trabalho";
import {AcessoService} from "../acesso/acesso.service";
import {AppComponent} from "../app.component";
import {Router} from "@angular/router";

declare var jQuery: any;


@Component({
    selector: 'app-trabalho-list',
    templateUrl: './trabalho-list.component.html',
    styleUrls: ['./trabalho-list.component.css'],
    providers: [TrabalhoService, AcessoService]
})
export class TrabalhoListComponent extends AppComponent implements OnInit {

    trabalhos: Trabalho[];
    aplicacao: AppComponent;
	orcamento: string;
	carregado: boolean = false;

    getTrabalhos() {
        this.trabalhoService.getTrabalhosPorUsuario().then(trabalhos => {
			this.trabalhos = trabalhos; 
			for (let i in trabalhos) { 
				if (trabalhos[i].orcamento_utilizado) 
					trabalhos[i].orcamento_utilizado = (trabalhos[i].orcamento_utilizado / 100).toFixed(2);
				this.trabalhoService.getEtapas(trabalhos[i].id).then(etapas => { 
					this.setEtapas(this.trabalhos[i], etapas);
					if (i == (trabalhos.length - 1).toString())
						this.carregado = true;
				});
			}
		});
	}
	
    del(id,tipo){
      if(tipo.toUpperCase()==="CO-AUTOR"){
          return alert("Somente o responsável pela proposta pode removê-la.");
      }
        let del = confirm("Você deseja apagar esta proposta? Esta ação não pode ser desfeita.");
        let data = new Object();
        data['id'] = id;
        if (del) {
            this.trabalhoService.del(data).then(
                () => this.del_line(id)
            );
        }
    }

    del_line(id) {
        jQuery('#trab_' + id).remove();

    }

    ngOnInit() {
        if (!this.islogged()) 
            this.router.navigateByUrl('acesso');
        else
			this.getTrabalhos();
    }
	
	menosDe20Dias(trabalho: Trabalho): boolean {
		let data: any = trabalho.datas_ini[0].date;
		return (new Date(data.year, data.month - 1, data.day, 0, 0, 0, 0).getTime() - new Date().getTime()) <= 20 * 24 * 60 * 60 * 1000; 
	}
	
	enviarOrcamento(trabalho: Trabalho) : void {
		let orcamento: any = this.orcamento;
		if (!this.orcamento)
			this.utils.exibirMensagem('Faltou definir o orçamento!', 'warning');
		else if (orcamento > 10000.00)
			this.utils.exibirMensagem('O orçamento não pode ser maior do que R$ 10000,00!', 'warning');
		else if (!Number.isInteger(orcamento *= 100))
			this.utils.exibirMensagem('Orçamento inválido', 'warning');
		else if (window.confirm("Tem certeza que quer continuar? Esta ação não pode ser desfeita!")) {
			this.trabalhoService.salvarOrcamento(trabalho.id, orcamento);
			trabalho.orcamento_utilizado = (orcamento / 100).toFixed(2);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/trabalho-list/trabalho-list.component.ts